import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  overlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    display: 'block',
    flex: 1,
  },
}))

export default useStyles
